import styled from 'styled-components'

export const Content = styled.div`
  img{
    margin-top: 10px;
    margin-bottom: 10px;
  }
`

export const BigTitle = styled.div`
  padding: 5px;
  font-weight: bolder;
  font-size: 24px;
`

export const Title = styled.div`
  padding: 5px;
  font-weight: bolder;
  font-size: 18px;
`

export const Paragraph = styled.div`
  padding: 5px;
  font-size: 14px;
  width: 560px;
  margin: 10px auto;
`
export const ParagraphBold = styled.div`
  padding: 5px;
  font-size: 14px;
  width: 560px;
  margin: 10px auto;
  font-weight: 600;
`

export const Notification = styled.div`
  padding: 10px;
  font-size: 14px;
  background-color: #EAF9FF;
  color: #F4420B;
  width: 560px;
  margin: 10px auto;
  border-radius: 8px;
  font-weight: 500;
`
